import React from 'react'
import imgBaseUrl from "../../../utils/imgBaseUrl";
import {MyTooltip} from "../tooltip/Tooltip";
import {KTIcon} from "../../../../_metronic/helpers";
import {separateFormatter} from "../../../utils/separateFormatter";
import moment from "moment/moment";
import {Link, useParams} from "react-router-dom";
import {ILessonItem} from "../../../types/lesson";
import {useDeleteModal} from "../../../context/DeleteModalContext";
import {MODERATOR_COURSE_LESSON} from "../../../mock/URLs";

type LessonCardProps = {
  lesson: ILessonItem,
  refetchLesson: () => void,
}

export const LessonCard = ({
                             lesson,
                             refetchLesson,
                           }: LessonCardProps) => {

  const {openDeleteModal} = useDeleteModal()
  const {courseId} = useParams()

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_COURSE_LESSON, id, refetchLesson);
  };

  return (
      <div>
        <div className="card mb-3 h-100">
          <div className="row g-0 h-100">
            <div className="col-md-4">
              <img src={imgBaseUrl(lesson?.image!)}
                   className="card-img w-100 h-100 object-fit-cover"
                   alt={lesson?.title}/>
            </div>
            <div className="col-md-8">
              <div className="card-body">
                <h5 className="card-title text-truncate">{lesson?.title}</h5>
                <p className="card-text text-truncate">{lesson?.description}</p>
                <div className={"d-flex flex-wrap gap-2"}>
                  <MyTooltip title={"Videolar"} position={"top"}>
                                    <span className={"btn btn-light-primary btn-sm"}>
                                    <KTIcon iconName={"to-right"} className={"fs-1"}/>
                                      {separateFormatter(lesson?.video_count!, " ", "")}
                                  </span>
                  </MyTooltip>

                  <MyTooltip title={"Audiolar"} position={"top"}>
                                  <span className={"btn btn-light-info btn-sm"}>
                                    <KTIcon iconName={"speaker"} className={"fs-1"}/>
                                    {separateFormatter(lesson?.audio_count!, " ", "")}
                                  </span>
                  </MyTooltip>

                  <MyTooltip title={"Testlar"} position={"top"}>
                                  <span className={"btn btn-light-danger btn-sm"}>
                                    <KTIcon iconName={"question-2"} className={"fs-1"}/>
                                    {separateFormatter(lesson?.test_count!, " ", "")}
                                  </span>
                  </MyTooltip>

                  <MyTooltip title={"Dokumentlar"} position={"top"}>
                                  <span className={"btn btn-light-warning btn-sm"}>
                                    <KTIcon iconName={"notepad-bookmark"} className={"fs-1"}/>
                                    {separateFormatter(lesson?.document_count!, " ", "")}
                                  </span>
                  </MyTooltip>

                  <MyTooltip title={"Yoqtirishlar soni"} position={"top"}>
                                    <span className={"btn btn-light-danger btn-sm"}>
                                      <KTIcon iconName={"like"} className={"fs-1"}/>
                                      {separateFormatter(lesson?.likes_count!, " ", "")}
                                    </span>
                  </MyTooltip>

                  <MyTooltip title={"Talabalar"} position={"top"}>
                                    <span className={"btn btn-secondary btn-sm"}>
                                      <KTIcon iconName={"people"} className={"fs-1"}/>
                                      {separateFormatter(lesson?.students_count!, " ", "")}
                                    </span>
                  </MyTooltip>
                </div>

                <p className="card-text mt-3"><small
                    className="text-muted">{moment(lesson?.created_at).format("DD.MM.YYY HH:mm")}</small>
                </p>

                <div className={"d-flex justify-content-between"}>
                  <Link to={`/courses/${courseId}/lesson/update/${lesson?.id}`}
                        className={"btn btn-sm  btn-light-primary"}>
                    <KTIcon iconName={"pencil"} className={"fs-4"}/>
                    Tahrirlash
                  </Link>
                  <div>
                    <Link to={`/courses/${courseId}/lesson/${lesson?.id}/resource/create`}
                          className="btn btn-sm btn-primary me-1">
                      <KTIcon iconName={"plus-square"} className={"pe-2 fs-3"}/>
                      Resurs qo'shish
                    </Link>

                    <Link to={`/courses/${courseId}/lesson/${lesson?.id}/test/create`}
                          className="btn btn-sm btn-icon btn-secondary me-1">
                      <KTIcon iconName={"question-2"} className={"fs-3"}/>
                    </Link>

                    <button className="btn btn-sm btn-icon btn-danger me-1" onClick={() => {
                      handleDeleteClick(lesson.id)
                    }}>
                      <KTIcon iconName={"trash-square"} className={"pe-0 fs-3"}/>
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
  )
}
